import { activeColorScheme } from '@genesislcap/foundation-utils';
import { textFieldStyles as fastTextFieldStyles } from '@microsoft/fast-components';
import { css } from '@microsoft/fast-element';
export const foundationTextFieldStyles = (context, definition) => css `
  ${fastTextFieldStyles(context, definition)}

  input {
    color-scheme: ${activeColorScheme};
  }
`;
